<template>
  <OneButtonModal
    :is-visible="isVisible"
    :is-close-button-visible="true"
    style-modifier="transparent"
    @button-click="emitButtonEvents"
    @hide-modal="emitHideModalEvent"
  >
    <div slot="image" class="simulation-exam-price-modal__img">
      <div class="simulation-exam-price-modal__twelve-coins-img">
        <div class="twelve-coins-img__img">
          <TwelveCoinsImage />
        </div>
      </div>
    </div>

    <div slot="message" class="simulation-exam-price-modal__message">
      <p>
        Este exámen tiene un costo de 550 monedas.
      </p>
    </div>

    <span slot="buttonText" class="simulation-exam-price-modal__btn-text">Comenzar</span>
  </OneButtonModal>
</template>

<script>
// eslint-disable-next-line import/extensions
import TwelveCoinsImage from "@/assets/twelve-coins.svg?inline";
import OneButtonModal from "@/components/one_button_modal/OneButtonModal.vue";

export default {
  name: "SimulationExamPriceModal",
  components: {
    OneButtonModal,
    TwelveCoinsImage,
  },
  model: {
    prop: "isVisible",
    event: "hide-modal",
  },
  props: {
    isCloseButtonVisible: {
      type: Boolean,
      default: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
    simulationExam: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitButtonEvents() {
      this.emitContinueWithSimulationExam();
      this.emitHideModalEvent();
    },
    emitHideModalEvent() {
      this.$emit("hide-modal", false);
    },
    emitContinueWithSimulationExam() {
      this.$emit("continue-with-simulation-exam", this.simulationExam);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/scss/_colors.scss";
@import "~@/scss/_typography.scss";

/** @define simulation-exam-price-modal */
.simulation-exam-price-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: $overlay-color;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.simulation-exam-price-modal__twelve-coins-img {
  width: 100%;
  flex-direction: row;
  justify-items: center;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}

.simulation-exam-price-modal__message {
  margin: 2em 0;
}

.simulation-exam-price-modal__twelve-coins {
  width: 100%;
  display: flex;
}

/** @define twelve-coins */
.twelve-coins__img {
  width: 30%;
  margin-left: 4em;

  @include laptop {
    width: 20%;
  }
}

/** @define twelve-coins-img */
.twelve-coins-img__img {
  width: 25em;
  @include laptop {
    width: 35em;
  }
}
</style>
